<template>
  <div class="header-wrapper">
    <div class="header_left">
      <img v-if="screenWidth > 600" src="/static/images/homepage/zljy-logo.png" alt="" @click="$router.push('/Home')">
      <el-button v-if="flag&&flag==1" @click="goback" class="goback"><i class="el-icon-arrow-left"></i> 教学空间</el-button>
      <el-button v-else-if="flag&&flag==2" @click="$router.push('/TheoryCourse/CourseLibrary')" class="goback"><i
        class="el-icon-arrow-left"></i> 课程库
      </el-button>
      <p @click="$router.push('/Home')" v-else>
        <i class="el-icon-sort"></i>
        {{ prodName ? prodName : deptName }}
        <span v-if="licenseCode" class="codeStyle">许可证编码：{{ licenseCode }}</span>
      </p>

    </div>
    <div class="header_right" v-if="!notOut">
      <ul class="right_menu" v-if="false">
        <!-- <li @click="handleCommand('s')" v-if="userType==0" :class="{active : 2===curId}"><span>数据中心</span></li> -->
        <li @click="handleCommand('a')" v-if="isPlatformadmin" :class="{active : 0===curId}"><span>教务中心</span></li>
        <li @click="handleCommand('b')" :class="{active : 1===curId}"><span>个人中心</span></li>
      </ul>
      <div class="login-user">
        <el-dropdown @command="handleCommand" :show-timeout="0">
          <div class="user-name el-dropdown-link">
            <div class="imgBox">
              <img :src="imgUrl">
            </div>
            <div class="login-name">{{name}}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="a">教务中心</el-dropdown-item> -->
            <!-- <el-dropdown-item command="b">个人中心</el-dropdown-item> -->
            <el-dropdown-item command="d">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      flag: {
        type: [String, Number],
      },
      notOut: {  // 传入此值后，不展示退出的选项
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        screenWidth: '',
        name: '',
        userType: '',
        // imgUrl:'../../../static/images/homepage/headPic.png',
        imgUrl: '../../../static/images/hed0.png',
        professional: sessionStorage.getItem('professional') ? sessionStorage.getItem('professional') : 2,
        isPlatformadmin: sessionStorage.getItem('isPlatformadmin'),
        curId: 0,
        prodName: sessionStorage.getItem('prodName'),
        deptName: sessionStorage.getItem('deptName'),
        licenseCode: '',
      }
    },
    created() {
      if (this.$route.path.split('/')[1] == 'educa') {
        this.curId = 0
      } else if (this.$route.path.split('/')[1] == 'settings') {
        this.curId = 1
      } else if (this.$route.path.split('/')[1] == 'dataStatistics') {
        this.curId = 2
      } else {
        this.curId = 3
      }
      if (localStorage.getItem('isbinding') && localStorage.getItem('isbinding') == 0) {
        this.$router.push({path: '/'})
      }
      this.name = sessionStorage.getItem('loginName');
      this.userType = sessionStorage.getItem('userType');

      // 深圳本地部署，要求  许可证编码
      // if(this.prodName && process.env.NODE_ENV === 'native'){
      //   if (this.prodName.includes('财务大数据')) {
      //     this.licenseCode = 'ZL20240620D002'
      //   } else if (this.prodName.includes('金融大数据')) {
      //     this.licenseCode = 'ZL20240620J004'
      //   } else if (this.prodName.includes('区块链金融')) {
      //     this.licenseCode = 'Zl20240620J005'
      //   }
      // }
    },
    mounted() {
      this.screenWidth = document.body.clientWidth;
    },
    methods: {
      handleCommand(command) {
        if (command == 'd') {
          this.$logOut()
        } else if (command == 'a') {
          this.$router.push('/educa')
        } else if (command == 'b') {
          this.$router.push('/settings')
        } else if (command == 's') {
          this.$router.push('/dataStatistics')
        }
      },
      goback() {
        if (this.userType == 0 || this.userType == 1) {
          this.$router.push({
            path: "/TheoryCourse/TeachingClass"
          })
        } else {
          this.$router.push({
            path: "/n-study/courseware"
          })
        }
      }
    },
    watch: {
      '$route'(to, from) {
        if (to.path.split('/')[1] == 'educa') {
          this.curId = 0
        } else if (to.path.split('/')[1] == 'settings') {
          this.curId = 1
        } else if (to.path.split('/')[1] == 'dataStatistics') {
          this.curId = 2
        } else {
          this.curId = 3
        }
      }
    }
  }

</script>

<style scoped lang="scss">
  .header-wrapper {
    width: 100%;
    height: 64px;
    background: #fff;
    display: flex;
    justify-content: space-between;

    .header_left {
      display: flex;
      align-items: center;

      .codeStyle{
        font-size: 13px;
        color: #004E96;
        font-weight: 400;
        margin-left: 20px;
        letter-spacing: 1px;
      }

      img {
        height: 28px;
        margin-left: 25px;
        margin-right: 25px;
      }

      p {
        font-size: 16px;
        color: #004E96;
        position: relative;
        margin-left: 25px;
        cursor: pointer;
        letter-spacing: 2px;
        font-weight: 600;

        &::after {
          content: '';
          position: absolute;
          left: -20px;
          top: 0px;
          bottom: 0px;
          width: 2px;
          height: 20px;
          background: #004E96;
          margin: auto;
        }

        i {
          transform: rotate(90deg);
          margin-right: 5px;
          color: #004E96;
        }
      }

      .goback {
        width: 90px;
        height: 27px;
        border: none;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        color: #004E96;
        box-sizing: border-box;
        position: relative;
        padding: 0;
        margin-left: 20px;

        i {
          color: #004E96;
          font-weight: 600;
        }

        &::after {
          content: "";
          position: absolute;
          left: 4px;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 16px;
          height: 16px;
          // background: url("/static/images/newCourse/home.png") no-repeat;
          // background-size: 100% 100%;
        }

        &:hover {
          color: #1890FF;
          background: none;

          i {
            color: #1890FF;
          }

          // &::after{
          //   background: url("/static/images/newCourse/homeActive.png") no-repeat;
          //   background-size: 100% 100%;
          // }
        }

        &::before {
          content: "";
          position: absolute;
          left: -15px;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 2px;
          height: 20px;
          background: #004E96;
        }
      }
    }

    .header_right {
      display: flex;

      .right_menu {
        display: flex;
        align-items: center;
        margin-right: 24px;

        li {
          position: relative;
          width: 100px;
          text-align: center;
          cursor: pointer;

          span {
            color: #0F0D11;
            font-size: 12px;
            font-weight: normal;
            letter-spacing: 1px;
          }

          &::after {
            content: '';
            width: 1px;
            height: 12px;
            background: #0F0D11;
            position: absolute;
            right: 0;
            top: 4px;
          }
        }

        .active {
          span {
            // color: darkorange;
            color: #0F0D11;
            font-weight: 600;
            font-size: 14px;
          }
        }
      }
    }

    .login-user {
      cursor: pointer;
      display: flex;

      .login-name {
        margin-left: 6px;
        color: #0F0D11;
        line-height: 20px;
      }

      .user-name {
        height: 100%;
        display: flex;
        align-items: center;

        .imgBox {
          width: 30px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border: 1px solid #333;
          border-radius: 50%;

          img {
            height: 100%;
          }
        }
      }

      .el-dropdown {
        display: inline-block;
        margin-right: 32px;
      }

      &:hover {
        .login-name {
          opacity: 0.8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/new-header.vue